/* eslint-disable no-unsafe-optional-chaining */
import { Vendor } from '@models/response/vendor';
import { BankType, PaymentServiceType } from '@models/ropolo';
import { ActionReducerMapBuilder, createSlice } from '@reduxjs/toolkit';
import { BankPaymentServiceType } from '../../models/response/banks';
import { getBankConfigurationService } from '../../services/payment';
import { createAppAsyncThunk } from '../../utils/reduxUtil';

interface BankConfig extends BankType {
  title?: string;
  remaining?: number;
}

export interface BankConfigurationQueryResponse {
  bankTypes?: BankConfig[] | null;
  preSelectedProvider?: PaymentServiceType;
}

export interface BankConfigurationQueryResponseResponseMessage {
  data?: BankConfigurationQueryResponse;
  status?: string | null;
}

interface BankConfigurationResponse extends BankConfigurationQueryResponseResponseMessage {}

type bankState = {
  banks: BankConfigurationResponse | undefined;
  loading: boolean;
  selectedPaymentBank: BankPaymentServiceType | undefined;
};

const initialState: bankState = {
  banks: undefined,
  loading: false,
  selectedPaymentBank: undefined,
};

type BankConfigurationsPayload = {
  amount: number;
  vendor: Vendor;
};

export const getBankConfigurations = createAppAsyncThunk<BankConfigurationResponse, BankConfigurationsPayload>(
  'address/getBankConfigurations',
  async ({ amount }) => {
    const response = await getBankConfigurationService();
    if (amount) {
      // let debitRes;
      // let payLaterRes;

      // if (vendor?.directDebitEnabled) {
      //   debitRes = await snappPayBalanceDetail(amount, SnappPayType.DIRECTDEBIT);
      //   payLaterRes = await snappPayBalanceDetail(amount, SnappPayType.POSTPAID);
      // }

      return {
        ...response,
        data: {
          ...response.data,
          bankTypes: [
            ...(response.data?.bankTypes || []),
            // ...(payLaterRes?.data?.amount !== 0
            //   ? [
            //       {
            //         type: PaymentServiceType.SNAPP_PAY_POSTPAID,
            //         isActive: payLaterRes?.data?.isValid,
            //         remaining: payLaterRes?.data?.amount,
            //       },
            //     ]
            //   : []),
            // {
            //   type: PaymentServiceType.SNAPP_PAY_DIRECTDEBIT,
            //   isActive: debitRes?.data?.isValid,
            //   remaining: payLaterRes?.data?.amount,
            // },
          ],
          // preSelectedProvider: debitRes?.data?.isValid
          //   ? PaymentServiceType.SNAPP_PAY_DIRECTDEBIT
          //   : response.data?.preSelectedProvider,
          preSelectedProvider: response.data?.preSelectedProvider,
          // ? PaymentServiceType.SNAPP_PAY_DIRECTDEBIT
          // : response.data?.preSelectedProvider,
        },
      };
    }

    return { ...response };
  }
);

const bankSlice = createSlice({
  name: 'bankSlice',
  initialState,
  reducers: {
    setBankConfiguration: (state, action) => ({
      ...state,
      selectedPaymentBank: action.payload,
    }),
  },
  extraReducers: (builder: ActionReducerMapBuilder<bankState>) => {
    builder.addCase(getBankConfigurations.pending, (state) => ({ ...state, loading: true }));
    builder.addCase(getBankConfigurations.fulfilled, (state, action) => ({
      ...state,
      loading: false,
      banks: action.payload,
      selectedPaymentBank: action.payload?.data?.preSelectedProvider,
    }));
    builder.addCase(getBankConfigurations.rejected, (state) => ({
      ...state,
      loading: false,
    }));
  },
});

export default bankSlice;
